/*
 * Cambia el nav de escritorio por el menu de hamburguesa cuando los items ya no
 * caben en el ancho que tiene asignado, midiendolo en vez de usar un breakpoint
 * fijo.
 *
 * El nav es un flex item con min-width:auto y sus items son white-space:nowrap,
 * asi que cuando no le alcanza el espacio NO se recorta: crece hasta su
 * min-content y empuja al logo y a los cart links fuera del header.
 */
(function () {
  'use strict';

  var COLLAPSED = 'nav--collapsed';

  function widthOf(element) {
    return element.getBoundingClientRect().width;
  }

  // Con getBoundingClientRect en vez de clientWidth para no perder los
  // subpixeles: el ancho del nav sale de un calc() con porcentajes y casi nunca
  // cae en un entero.
  function contentWidth(element) {
    var style = window.getComputedStyle(element);

    return widthOf(element)
      - parseFloat(style.paddingLeft)
      - parseFloat(style.paddingRight);
  }

  function gapOf(element) {
    return parseFloat(window.getComputedStyle(element).columnGap) || 0;
  }

  /*
   * Se compara contra el ancho que el nav tiene asignado, no contra el que
   * termina ocupando. Para eso se le pone min-width:0 mientras se mide: asi deja
   * de crecer por su min-content y se queda exactamente en su flex-basis, y los
   * items se desbordan de verdad cuando no caben.
   *
   * Comparar la suma de la fila contra el contenedor no sirve: esa suma sale de
   * porcentajes y de 1em que se resuelve contra el font-size de cada elemento,
   * asi que arrastra un error de unos pocos px incluso cuando todo cabe.
   */
  function itemsOverflow(nav, list) {
    var items = list.children;
    var needed = 0;
    var available;
    var i;

    nav.style.minWidth = '0';

    for (i = 0; i < items.length; i++) {
      needed += widthOf(items[i]);
    }

    if (items.length > 1) {
      needed += gapOf(list) * (items.length - 1);
    }

    available = contentWidth(list);

    nav.style.minWidth = '';

    return needed > available + 1;
  }

  function init(header) {
    var container = header.querySelector('.nav-container');
    var nav = header.querySelector('.header-navigation');
    var list = header.querySelector('#main-nav');

    if (!container || !nav || !list || !list.children.length) return;

    var frame = null;
    var lastWidth = -1;

    function update() {
      frame = null;

      // Hay que medir expandido: colapsado el nav es display:none y no tiene
      // ancho. Quitar y reponer la clase pasa dentro del mismo frame, antes de
      // pintar, asi que no parpadea.
      container.classList.remove(COLLAPSED);

      // Abajo de 980px el tema ya oculta el nav y muestra el hamburger solo.
      if (window.getComputedStyle(nav).display === 'none') return;

      if (itemsOverflow(nav, list)) {
        container.classList.add(COLLAPSED);
      }
    }

    function schedule() {
      if (frame === null) {
        frame = window.requestAnimationFrame(update);
      }
    }

    if ('ResizeObserver' in window) {
      new window.ResizeObserver(function (entries) {
        // Solo el ancho importa. Ignorar el alto evita volver a medir cuando
        // colapsar el nav cambia la altura del header.
        var width = entries[0].contentRect.width;

        if (width === lastWidth) return;

        lastWidth = width;
        schedule();
      }).observe(container);
    } else {
      window.addEventListener('resize', schedule);
    }

    // Las etiquetas cambian de ancho cuando entra la tipografia real en lugar
    // de la de respaldo, asi que hay que volver a medir.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }

    update();
  }

  function initAll() {
    var headers = document.querySelectorAll('.header-section');
    var i;

    for (i = 0; i < headers.length; i++) {
      init(headers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El editor de temas vuelve a renderizar la seccion al cambiar settings.
  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('.header-section');
    if (header) init(header);
  });
})();
